import {Link} from 'react-router-dom'
import SearchBar from './SearchBar'
import Catagories from './Catagories'
import SideBarTitle from './SideBarTitle'
import BlogNewsletter from './BlogNewsletter'

function BlogContent() {
  return (
<section className="standard-blog-area">
  <div className="container">
    <div className="row justify-content-center">
      <div className="col-lg-8">
        <div className="standard-blog-item">
          <div className="standard-blog-thumb">
            <Link to="/blog-details"><img src="img/blog/blog_thumb01.jpg" alt="" /></Link>
          </div>
          <div className="standard-blog-content">
            <div className="blog-post-meta">
              <ul>
                <li className="tags"><i className="flaticon-bookmark-1" />
                  <a href="/#">Husky Sibérien , </a>
                  <a href="/#">Race</a>
                </li>
                <li><i className="far fa-user" /><a href="/#">Admin</a></li>
                <li><i className="far fa-bell" /> 10 Mars 2021</li>
              </ul>
            </div>
            <h2 className="title"><Link to="/blog-details">Animalia Plus – Tout pour votre animal en ligne</Link></h2>
            <p>Le chien domestique est un descendant domestiqué du loup. Il provient d’un loup ancien aujourd’hui éteint, et le loup gris moderne est son plus proche parent. Le chien est la première espèce à avoir été domestiquée par l’homme.</p>
            <Link to="/blog-details" className="read-more">Lire la suite <img src="img/icon/pawprint.png" alt="" /></Link>
          </div>
        </div>

        <div className="standard-blog-item">
          <div className="standard-blog-thumb">
            <Link to="/blog-details"><img src="img/blog/blog_thumb02.jpg" alt="" /></Link>
          </div>
          <div className="standard-blog-content">
            <div className="blog-post-meta">
              <ul>
                <li className="tags"><i className="flaticon-bookmark-1" />
                  <a href="/#">Husky Sibérien , </a>
                  <a href="/#">Race</a>
                </li>
                <li><i className="far fa-user" /><a href="/#">Admin</a></li>
                <li><i className="far fa-bell" /> 10 Mars 2021</li>
              </ul>
            </div>
            <h2 className="title"><Link to="/blog-details">Les animaux ont besoin d'une alimentation spéciale, comme les humains</Link></h2>
            <p>Le chien domestique est un descendant domestiqué du loup. Il provient d’un loup ancien aujourd’hui éteint, et le loup gris moderne est son plus proche parent. Le chien est la première espèce à avoir été domestiquée par l’homme.</p>
            <Link to="/blog-details" className="read-more">Lire la suite <img src="img/icon/pawprint.png" alt="" /></Link>
          </div>
        </div>

        <div className="standard-blog-item">
          <div className="standard-blog-thumb">
            <Link to="/blog-details"><img src="img/blog/blog_thumb03.jpg" alt="" /></Link>
          </div>
          <div className="standard-blog-content">
            <div className="blog-post-meta">
              <ul>
                <li className="tags"><i className="flaticon-bookmark-1" />
                  <a href="/#">Husky Sibérien , </a>
                  <a href="/#">Race</a>
                </li>
                <li><i className="far fa-user" /><a href="/#">Admin</a></li>
                <li><i className="far fa-bell" /> 10 Mars 2021</li>
              </ul>
            </div>
            <h2 className="title"><Link to="/blog-details">Emballages spéciaux pour aliments à emporter</Link></h2>
            <p>Le chien domestique est un descendant domestiqué du loup. Il provient d’un loup ancien aujourd’hui éteint, et le loup gris moderne est son plus proche parent. Le chien est la première espèce à avoir été domestiquée par l’homme.</p>
            <Link to="/blog-details" className="read-more">Lire la suite <img src="img/icon/pawprint.png" alt="" /></Link>
          </div>
        </div>
      </div>

      <div className="col-lg-4 col-md-8">
        <aside className="blog-sidebar">
          <SearchBar />
          <Catagories />
          <div className="widget">
            <h4 className="sidebar-title">Articles Récents</h4>
            <SideBarTitle />
          </div>
          <BlogNewsletter />
        </aside>
      </div>
    </div>
  </div>
</section>

  )
}

export default BlogContent;
